function BalanceSheet() {
    return (
        <div>
            <h1>Balance Sheet</h1>
            <p style={{ fontStyle: 'italic' }}>Note: We need data for this.</p>
        </div>
    );
}

export default BalanceSheet;